import { abortableFetch, useEventCallback } from '@eas/common-web';
import { createParticipantRequestTarget } from '@composite/participants/participant-create-utils';
import { AccessoryParticipant, EsFile } from '@models';
import { EvidenceApiUrl, ParticipantType } from '@enums';

export function useAddAccessoryParticipantDialog() {
  const callApi = useEventCallback(
    (formData: AccessoryParticipant, esFile: EsFile | undefined) => {
      const requestTarget = createParticipantRequestTarget(
        esFile,
        EvidenceApiUrl.ES_FILES
      );

      return abortableFetch(requestTarget.url, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
          ...formData,
          type: ParticipantType.ACCESSORY_PARTICIPANT,
          esFile: requestTarget.esFile,
        }),
      });
    }
  );

  return {
    callApi,
  };
}
